/**
 * Technology & Digital Reach Translations Module (Spanish)
 * 
 * Contains: Website Analytics, Social Media, LEADER Magazine, Technology Trends
 * 
 * @module technology
 * @language es
 */

export const technology = {
  technologyFuture: {
    pageTitle: "Tecnología y Alcance Digital",
    pageSubtitle: "JCI.cc • Redes Sociales • Revista LEADER | 260K+ seguidores, 70+ países"
  },
  technologyRole: {
    title: "Rol de la Tecnología",
    subtitle: "Cómo JCI usa la tecnología para conectar y empoderar a jóvenes líderes",
    new: "NUEVO"
  },
  programs: {
    jciWebsite: "Sitio Web JCI.cc",
    website: "Sitio Web",
    socialMedia: "Redes Sociales",
    social: "Social",
    leaderMagazine: "Revista LEADER",
    magazine: "Revista",
    activeUsers: "Usuarios Activos",
    pageViews: "Vistas de Página",
    avgSession: "Sesión Promedio",
    bounceRate: "Tasa de Rebote",
    returnVisitors: "Visitantes Recurrentes",
    mobileAccess: "acceso vía móvil",
    mobileFirstApproach: "Enfoque móvil primero esencial",
    deviceBreakdown: "Desglose por Dispositivo",
    trafficSources: "Fuentes de Tráfico",
    topGeographicSources: "Principales Fuentes Geográficas",
    largest: "Mayor",
    topPagesVisited: "Páginas Más Visitadas",
    combinedFollowers: "Seguidores Combinados",
    monthlyImpressions: "Impresiones Mensuales",
    organicGrowth: "Crecimiento Orgánico",
    avgEngagement: "Engagement Promedio",
    followers: "Seguidores",
    topContent: "Contenido Principal",
    topVideo: "Video Principal",
    views: "vistas",
    retention: "retención",
    totalReaders: "Lectores Totales",
    bookVisits: "Visitas al Libro",
    avgReadTime: "Tiempo Promedio de Lectura",
    countries: "Países",
    keyInsight: "Información Clave",
    readersPerIssue: "Lectores por Edición (7 Ediciones, Ene-Oct 2025)",
    readTimeTrend: "Tendencia de Tiempo de Lectura (Engagement Creciente)",
    deviceAccess: "Acceso por Dispositivo",
    regionalReach: "Alcance Regional",
    contentThemes: "Temas de Contenido",
    devices: {
      desktopLaptop: "Escritorio/Laptop",
      mobilePhone: "Teléfono Móvil",
      tablet: "Tablet"
    },
    trafficSourceTypes: {
      organicSearch: "Búsqueda Orgánica",
      direct: "Directo",
      referral: "Referencia",
      paid: "Pagado",
      goodSeoVisibility: "Buena visibilidad SEO",
      strongBrandRecognition: "Fuerte reconocimiento de marca",
      socialPartnerships: "Social + alianzas",
      limitedCampaigns: "Campañas limitadas"
    },
    topPagesData: {
      aboutJci: "Sobre JCI",
      newsEvents: "Noticias y Eventos",
      whatWeDo: "Qué Hacemos",
      programsPage: "Programas",
      getInvolved: "Participa",
      discoveringOrg: "Personas descubriendo la org",
      engagementSeeking: "Buscando engagement",
      programInterest: "Interés en programas",
      actionOriented: "Visitantes orientados a la acción",
      ctaMomentum: "Momentum de llamada a la acción"
    }
  },
  socialMediaData: {
    communityHub: "Centro de Comunidad",
    visualStorytelling: "Narrativa Visual",
    thoughtLeadership: "Liderazgo de Pensamiento",
    longFormContent: "Contenido de Formato Largo",
    fastestGrowth: "Crecimiento Más Rápido",
    consistentGrowth: "Crecimiento Constante",
    eventHighlights: "Destacados de eventos",
    memberStories: "Historias de miembros",
    campaigns: "Campañas",
    reels: "Reels (3x engagement)",
    visualStories: "Historias visuales",
    leadershipInsights: "Insights de liderazgo",
    partnerships: "Alianzas",
    trainingSessions: "Sesiones de capacitación",
    reach: "alcance",
    engagement: "engagement",
    impressions: "impresiones",
    interactions: "interacciones",
    watchTime: "tiempo de visualización",
    whatIsJci: "¿Qué es JCI?"
  },
  futureSkills: {
    communicationPublicSpeaking: "Comunicación y Oratoria",
    communicationDesc: "Esencial para liderazgo e influencia",
    criticalThinking: "Pensamiento Crítico y Resolución de Problemas",
    criticalThinkingDesc: "Habilidades analíticas para desafíos complejos",
    conflictResolution: "Resolución de Conflictos y Negociación",
    conflictResolutionDesc: "Gestionar disputas y construir consenso",
    projectManagement: "Gestión de Proyectos",
    projectManagementDesc: "Planificar y ejecutar iniciativas eficazmente",
    digitalTechLiteracy: "Alfabetización Digital y Tecnológica",
    digitalTechDesc: "Comprender herramientas tecnológicas modernas",
    financialLiteracy: "Alfabetización Financiera",
    financialLiteracyDesc: "Gestión de presupuestos y planificación financiera",
    interculturalCommunication: "Comunicación Intercultural",
    interculturalDesc: "Trabajar eficazmente entre culturas",
    advocacyInfluence: "Abogacía e Influencia",
    advocacyDesc: "Impulsar el cambio a través de la persuasión"
  },
  technology: {
    title: "Tecnología y Futuro",
    subtitle: "Adopción tecnológica y tendencias de innovación futura",
    memberProfile: "Perfil Tecnológico del Miembro",
    engagementMembers: "Engagement de Miembros",
    aiInLeadership: "IA en Liderazgo",
    transformative: "Transformador",
    aiDescription: "Las herramientas de IA para toma de decisiones, aprendizaje personalizado y automatización están transformando cómo los jóvenes líderes se desarrollan y lideran.",
    digitalFirstSkills: "Habilidades Digitales Primero",
    critical: "Crítico",
    digitalDescription: "Alfabetización de datos, marketing digital, programación y ciberseguridad son ahora habilidades esenciales para el avance profesional.",
    sustainabilityGreenTech: "Sostenibilidad y Tecnología Verde",
    essential: "Esencial",
    sustainabilityDescription: "Tecnología climática, energía renovable y soluciones de economía circular impulsando la sostenibilidad ambiental.",
    mentalHealthTech: "Tecnología de Salud Mental",
    growing: "Creciente",
    mentalHealthDescription: "Apps de bienestar mental, plataformas de teleterapia y chatbots de IA proporcionando apoyo accesible de salud mental.",
    keyFocusAreas: "Áreas de Enfoque Clave",
    source: "Fuente",
    trendsResearchSources: "Fuentes de Investigación de Tendencias",
    futureSkillsPriorities: "Prioridades de Habilidades Futuras 2025",
    futureSkillsSubtitle: "Competencias esenciales identificadas por miembros de JCI para desarrollo de liderazgo y éxito profesional",
    priority: "Prioridad",
    skillsDevelopmentFramework: "Marco de Desarrollo de Habilidades",
    skillsFrameworkDesc: "Estas prioridades guían los programas de capacitación, talleres e iniciativas de desarrollo de liderazgo de JCI. Los miembros identificaron estas competencias como las más críticas para navegar los desafíos en evolución de 2025 y más allá, con énfasis particular en comunicación, pensamiento crítico y alfabetización digital.",
    veryHigh: "Muy Alta",
    high: "Alta",
    medium: "Media",
    mediumHigh: "Media-Alta",
    emerging: "Emergente",
    // AI Focus Areas
    aiAugmentedDecision: "Toma de decisiones aumentada por IA",
    personalizedLearning: "Rutas de aprendizaje personalizadas",
    automatedAnalytics: "Analítica automatizada",
    ethicalAiGovernance: "Gobernanza ética de IA",
    // Digital Skills Focus Areas
    dataLiteracy: "Alfabetización de datos",
    digitalMarketing: "Marketing digital",
    programmingBasics: "Fundamentos de programación",
    cybersecurityAwareness: "Conciencia de ciberseguridad",
    // Green Tech Focus Areas
    climateTechnology: "Tecnología climática",
    renewableEnergy: "Energía renovable",
    circularEconomy: "Economía circular",
    esgMeasurement: "Medición ESG",
    // Mental Health Tech Focus Areas
    wellnessApplications: "Aplicaciones de bienestar",
    teletherapyPlatforms: "Plataformas de teleterapia",
    aiSupportChatbots: "Chatbots de apoyo IA",
    stressManagementTools: "Herramientas de gestión de estrés"
  }
} as const;
